{
  "sectionTitle": "Gemenskaper",
  "joinedAt": "Gick med {{date}}",
  "leave": "Lämna",
  "leaveTitle": "Lämna gemenskap?",
  "leaveBody": "Du kommer inte längre att se <strong>{{society}}s</strong> evenemang eller kunna registrera dig för dem. Du kan bara gå med igen med en ny inbjudan.",
  "invite": {
    "subtitle": "Bjöd in dig som medlem i gemenskapen",
    "accept": "Acceptera",
    "accepted": "Du gick med i gemenskapen {{society}}.",
    "decline": "Avböj",
    "declineTitle": "Avböj inbjudan?",
    "declineBody": "Vill du avböja inbjudan till gemenskapen <strong>{{society}}</strong>? Du kan bara gå med senare med en ny inbjudan."
  },
  "empty": {
    "title": "Du tillhör inga gemenskaper ännu",
    "description": "När du bjuds in till en gemenskap visas inbjudan här. Du kan också gå med med en kod."
  },
  "join": {
    "sectionTitle": "Gå med i en gemenskap",
    "description": "Ange gemenskapens anslutningskod eller skanna en QR-kod för att gå med.",
    "label": "Gå med i en gemenskap med kod:",
    "labelMore": "Gå med i en ny gemenskap med kod:",
    "codePlaceholder": "Anslutningskod",
    "submit": "Gå med",
    "scanQr": "Skanna QR-kod",
    "success": "Du gick med i gemenskapen {{society}}.",
    "error": "Anslutningen misslyckades. Kontrollera koden och försök igen.",
    "scanTitle": "Skanna anslutningskod",
    "scanInstructions": "Rikta kameran mot gemenskapens QR-kod.",
    "scanCameraError": "Kameran kunde inte användas. Kontrollera kamerabehörigheterna."
  },
  "joinLanding": {
    "title": "Du håller på att gå med i gemenskapen {{society}}",
    "description": "Att gå med kräver ett Impact-konto. Skapa ett konto eller logga in så går du med automatiskt.",
    "createAccount": "Skapa konto",
    "signIn": "Logga in",
    "confirmAs": "Du är inloggad med kontot {{account}}. Vill du gå med med detta konto?",
    "confirm": "Gå med",
    "invalidTitle": "Länken är ogiltig",
    "invalidBody": "Inbjudningslänken är ogiltig eller har gått ut. Be gemenskapen om en ny länk. Du kan också gå med med en kod på din profilsida.",
    "errorTitle": "Något gick fel",
    "errorBody": "Det gick inte att ladda inbjudningslänken. Kontrollera din nätverksanslutning och försök igen.",
    "retry": "Försök igen",
    "goHome": "Gå till startsidan"
  }
}
